var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":"grey lighten-3","close":""},on:{"click:close":_vm.toggleFilter}},[_c('strong',[_vm._v(_vm._s(_vm.enquiryStatus.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }